<template>
  <div class="generic-header" @mousemove="onMouseMove" @touchmove="onMouseMove">
    <v-row align="center" class="hero-block my-16 perspective-container">
      <div v-if="heroImage" class="perspective-container hero-img" :style="{height : '100%', width: 'auto', maxWidth: '100%'}">
        <v-img
          :src="optimizedImageURL(heroImage, {maxWidth: 500})"
          :lazy-src="getMetaData(heroImage)['image-lazy-src']"
          height="100%"
          width="100%"
          contain
          :style="{transform: `rotate3d(0.5, -0.5, 0, ${mouseX * 40}deg)`}"
        />
      </div>
      <v-col cols="12" lg="10" xl="8" style="position: relative;">
        <h1 class="text-left d-block text-h3 text-lg-h1">{{title}}</h1>
        <h2 class="text-left d-block text-body-1" v-if="subtitle">{{subtitle}}</h2>
      </v-col>
    </v-row>
    <v-row >
      <v-col cols="12" md="5">
        <v-img v-if="logo" :src="optimizedImageURL(logo, {width: 150})" :width="150" :lazy-src="getMetaData(logo)['image-lazy-src']" class="mb-4" />
        <div v-if="author">{{author}}</div>
        <div v-if="socials">
          <template v-for="(social, i) in socials">
            <a
              :key="i"
              :href="social.link"
              rel="noopener"
              class="underline text-body-1 black--text text-decoration-none"
              target="_blank"
            >
              {{social.label}}
            </a>
            <span class="mx-2" :key="`divider-${i}`" v-if="i < socials.length - 1">|</span>
          </template>
        </div>
      </v-col>
      <v-col cols="12" md="7" class="mb-6 mb-md-16" v-if="heroText">
        <MarkdownBlock :text="heroText" class="text-body-1 hero-text" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { optimizedImageURL, getMetaData } from '@/services/OptimizedImage'
import MarkdownBlock from '@monogrid/vue-lib/lib/components/MarkdownBlock'
import ViewPort from '@monogrid/vue-lib/lib/mixins/Viewport'

export default {
  name: 'GenericHeroBlock',
  props: {
    heroImage: {
      type: Object,
      required: false
    },
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: false
    },
    socials: {
      type: [Array, null],
      required: false
    },
    heroText: {
      type: String,
      required: false
    },
    logo: {
      type: Object,
      required: false
    },
    author: {
      type: String,
      required: false
    }
  },
  components: {
    MarkdownBlock
  },
  mixins: [ViewPort],
  data () {
    return {
      mouseX: 0
    }
  },
  methods: {
    optimizedImageURL,
    getMetaData,
    onMouseMove (event) {
      this.mouseX = event.touches && event.touches.length > 0 ? event.touches[0].clientX : event.clientX
      this.mouseX = (this.mouseX - (this.viewPort.width / 2)) / this.viewPort.width
      this.mouseX *= 2
    }
  }
}
</script>
<style lang="scss" scoped>
.generic-header {
  position: relative;
  background-color: rgba(255, 255, 0, 0);
}

.hero-img {
  position: absolute;
  top: 0;
  left: 0;

  .v-image {
    opacity: 0.3;
    filter: brightness(1.5);
    // transform: rotate3d(0.5, -0.5, 0, 40deg);
  }
  // background-color: #000;

  // ::v-deep .v-image__image {
  //   mix-blend-mode: lighten;
  // }
}

.text-h3 {
  @include breakpoint('xs-only') {
    font-size: rem(50px) !important;
    line-height: rem(50px);
  }
}

.hero-block {
  min-height: 50vh;
  position: relative;
}

.hero-text {
  ::v-deep p {
    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
